/**
 * Dialog component for displaying full email thread when a message bubble is clicked.
 */

import React from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface EmailDialogProps {
  emailId: string | null;
  onClose: () => void;
  EmailThreadComponent?: React.ComponentType<{ emailId: string; sx?: any }>;
}

/**
 * Full-screen dialog showing the complete email thread.
 * Requires EmailThreadComponent to be injected; renders nothing if not provided.
 */
export function EmailDialog({ emailId, onClose, EmailThreadComponent }: EmailDialogProps) {
  if (!emailId || !EmailThreadComponent) return null;

  return (
    <Dialog
      open={Boolean(emailId)}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      sx={{
        "& .MuiDialog-paper": {
          height: "90vh",
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ p: 0 }}>
        <EmailThreadComponent emailId={emailId} sx={{ height: "100%" }} />
      </DialogContent>
    </Dialog>
  );
}
